import cEditLink from '#themes/default/default/components/editLink/editLink.js';
import cSkeleton from '#themes/default/default/components/skeleton/skeleton.js';
import cSvg from '#themes/default/default/components/svg/svg.js';

import getCardTitle from '#frontend/util/getCardTitle.js';

import template from './paymentSummary.html' with { type: 'html' };

export default {
	name: 'CPaymentSummary',
	components: {
		cEditLink,
		cSkeleton,
		cSvg
	},
	props: {
		customer: {
			type: Object,
			default: () => null
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		cardTitle() {
			return getCardTitle(this.payment.slug, this.t('paymentMethod_creditCard'));
		}
	},
	template
};
